<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <!-- <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item> -->
                    <el-form-item label="状态">
                        <el-select v-model="category_id" size="small" placeholder="请选择" clearable>
                            <el-option v-for="item  in type_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <!-- <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item> -->
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="username" label="姓名" show-overflow-tooltip width="100"></el-table-column>
                <el-table-column prop="sex" label="性别" show-overflow-tooltip width="55">
                    <template slot-scope="scope">
                        <span>{{scope.row.sex==1?'男':'女'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="birthday" label="出生日期" show-overflow-tooltip width="110"></el-table-column>
                <el-table-column prop="sex" label="地址" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.province_text}}/{{scope.row.city_text}}/{{scope.row.district_text}}
                            {{scope.row.address}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机" show-overflow-tooltip width="150"></el-table-column>
                <el-table-column label="处方图片" width="150" align="center">
                    <template slot-scope="scope">
                        <el-image style="width: 80px; height: 80px" v-if="scope.row.file_info"
                            :src="scope.row.file_info[0].url" :preview-src-list="[scope.row.file_info[0].url]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column prop="sex" label="状态" show-overflow-tooltip width="55">
                    <template slot-scope="scope">
                        <span>{{scope.row.status==1?'正常':'取消'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sex" label="审核状态" show-overflow-tooltip width="85" align="center">
                    <template slot-scope="scope">
                        <span>{{({0:'未审核',1:'通过',2:'拒绝'})[scope.row.examine]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="210">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">审核
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!--  -->
        <el-dialog title="详情" :visible.sync="dialogs" top="120px" width="50%" center class="dialogs"
            :close-on-click-modal='false'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-loading='editloading'>
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="类型名称：">
                                <span>{{form.username}}</span>
                            </el-form-item>
                            <el-form-item label="性别：">
                                <span>{{form.sex==1?"男":'女'}}</span>
                            </el-form-item>
                            <el-form-item label="出生日期：">
                                <span>{{form.birthday}}</span>
                            </el-form-item>
                            <el-form-item label="地址：">
                                <span>{{form.province_text}}/{{form.city_text}}/{{form.district_text}}
                                    {{form.address}}</span>
                            </el-form-item>
                            <el-form-item label="手机号：">
                                <span>{{form.phone}}</span>
                            </el-form-item>
                             <el-form-item label="处方图片：">
                                <el-image style="width: 120px; height: 120px" @click="opimg(form.file_info[0].url)"
                                    v-if="form.file_info" :src="form.file_info[0].url">
                                </el-image>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                           
                            <el-form-item label="病情描述：">
                                <span>{{form.description}}</span>
                            </el-form-item>
                            <el-form-item label="补充说明：">
                                <span>{{form.supplement}}</span>
                            </el-form-item>
                            <el-form-item label="审核：">
                                <el-radio-group v-model="form.examine">
                                    <el-radio :label="1">通过</el-radio>
                                    <el-radio :label="2">拒绝</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="拒绝理由：" v-if="form.examine==2" prop="examine_result">
                                <el-input type="textarea" :rows="2" placeholder="请输入拒绝理由" v-model="form.examine_result">
                                </el-input>
                            </el-form-item>

                        </el-col>
                    </el-row>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading='subloading' @click="submit('form')" size="small">确 定
                </el-button>
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 预览图片 -->
        <el-dialog :visible.sync="previewModel" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="previewUrl" class="w-100" />
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import Contentvotelist from "./yao.vue";
    export default {
        components: {
            Contentvotelist
        },
        data() {
            return {
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                mtheights: {
                    height: null,
                    "overflow": "auto",
                },

                // 
                NumList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'],
                eid: '',
                props: {
                    label: 'problem',
                    children: 'children'
                },
                wt_options: [],
                dialogs: false,
                form: {
                    examine_result:'',
                },
                rule: {
                   
                    examine_result: [{
                        required: true,
                        message: '请输入拒绝理由'
                    }],

                },
                fileListed: [],
                previewModel: false,
                previewUrl: '',
                editloading: false,

                subloading: false,
                type_options: [{
                        id: 0,
                        name: '待审核'
                    },
                    {
                        id: 1,
                        name: '通过'
                    },
                    {
                        id: 2,
                        name: '未通过'
                    },
                ],
                category_id: '',

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            this.begin()

        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                that.mtheights.height = window.innerHeight - 360 + 'px'

                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                    that.mtheights.height = window.innerHeight - 360 + 'px'

                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/medicine/Mlist", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        examine: this.category_id

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },

            // 新增
            add() {
                let that = this
                that.dialogs = true
                that.eid = '0'
                that.clear()
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls;
                        if (that.eid && that.eid != '0') {
                            urls = "/admin/pc/medicine/Mexamine"
                        } 
                        that.subloading = true
                        axios
                            .post(`${urls}`, {
                                id: that.eid,
                                examine: that.form.examine,
                                examine_result: that.form.examine_result,
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                                that.subloading = false
                            })
                            .catch(error => {
                                that.subloading = false

                            })
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },

            handleEdit(index, row) {
                let that = this
                that.dialogs = true
                that.eid = row.id
                that.clear()
                this.editloading = true
                axios
                    .post("/admin/pc/medicine/read", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.form = response.data.data
                        this.editloading = false
                    })
                    .catch(error => {})
            },

            handleDelete(index, row) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/medicine/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.search()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.message);
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            clear() {
                let that = this

            },
            opimg(url) {
                this.previewUrl = url
                this.previewModel = true
            }
        },

    };
</script>


<style scoped lang='scss'>
    .mr_ck {
        margin: 10px 0;
    }

    .f_w {
        font-weight: 600;
    }

    .bds {
        border-bottom: 1px solid #f5f5f5
    }

    .btn {
        margin-left: 20px;
    }

    .dialog-ibox-content {
        /deep/ .el-form-item__content {
            line-height: normal;
        }

        /deep/.el-form-item__label {
            line-height: normal;
        }
    }
</style>